import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { LogIn, UserCircle, Briefcase, Users } from 'lucide-react';

export default function Login() {
  const { login, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    setError(null);
    try {
      await login(email, password || 'demo');
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Login failed. Please try again.');
    }
  };

  const handleQuickLogin = async (presetEmail) => {
    setError(null);
    try {
      await login(presetEmail, 'demo');
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Quick login failed.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="brand-logo" style={{ margin: '0 auto 16px auto', width: '48px', height: '48px', fontSize: '1.5rem' }}>
            P
          </div>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '8px' }}>Prodexly Holidays</h1>
          <p style={{ color: 'var(--text-muted)' }}>Moroccan HR SaaS Portal</p>
        </div>

        {error && (
          <div style={{ background: 'rgba(244, 63, 94, 0.1)', color: 'var(--accent-rose)', padding: '12px', borderRadius: 'var(--radius-md)', marginBottom: '24px', fontSize: '0.9rem', border: '1px solid rgba(244, 63, 94, 0.2)' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Work Email</label>
            <input 
              type="email" 
              className="form-input" 
              placeholder="name@company.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input 
              type="password" 
              className="form-input" 
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <button 
            type="submit" 
            className="btn btn-primary" 
            style={{ width: '100%', padding: '12px', marginTop: '8px' }}
            disabled={loading}
          >
            {loading ? 'Authenticating...' : 'Sign In'}
            {!loading && <LogIn size={18} />}
          </button>
        </form>

        <div className="login-quick-accounts">
          <p style={{ color: 'var(--text-dim)', fontSize: '0.85rem', marginBottom: '16px', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Development Test Accounts
          </p>
          
          <button className="quick-btn" onClick={() => handleQuickLogin('youssef.hr@prodexly.com')} disabled={loading}>
            <Briefcase size={18} color="var(--primary-400)" />
            <div>
              <div style={{ fontWeight: 500, color: 'white' }}>Login as HR Admin</div>
              <div style={{ fontSize: '0.75rem' }}>Youssef El Fassi</div>
            </div>
          </button>

          <button className="quick-btn" onClick={() => handleQuickLogin('sara.manager@prodexly.com')} disabled={loading}>
            <Users size={18} color="var(--accent-amber)" />
            <div>
              <div style={{ fontWeight: 500, color: 'white' }}>Login as Manager (N+1)</div>
              <div style={{ fontSize: '0.75rem' }}>Sara Benali</div>
            </div>
          </button>

          <button className="quick-btn" onClick={() => handleQuickLogin('amine@prodexly.com')} disabled={loading}>
            <UserCircle size={18} color="var(--accent-emerald)" />
            <div>
              <div style={{ fontWeight: 500, color: 'white' }}>Login as Standard Employee</div>
              <div style={{ fontSize: '0.75rem' }}>Amine Lahlou</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
